<template>
  <div class="container-xl g-0 g-lg-2">
    <div class="row h-100 g-0 g-lg-2">
      <div class="col h-100">
        <div class="header-small d-flex row header-lowcy"
          :style="{ backgroundImage:this.headerbg?`url(${this.headerbg}) !important`:`` }">
          <div class="col-11 col-xl-5 col-lg-6 h-100 d-lg-flex">
            <div class="promo-form ic-form header-form itinerary-form mt-auto py-5 flex-grow-1  pb-0 ">
                <form class="
                  form-medium
                  jsFormHelpersConnections-Contener
                  jsStationAlerts
                " name="searchTrain" method="get">
                <h1 class="h3">{{$t("icsearch_lsp")}}</h1>
                <div>
                  <div class="typehead-container">
                    <slot name="lowcy-from">
                      <div role="combobox" aria-haspopup="listbox" aria-expanded="false" class="start mb-3 no-border">
                        <div class="input-group">
                          <input type="search" id="stname-0" name="stname[0]" 
                            :aria-label="$t('icsearch_aria_stacja_od')"
                            class="
                              jsStationTypeaheadItem
                              jsCzwartkomaniaNearestStationItem
                              form-control
                            " :placeholder="$t('icsearch_stacja_poczatkowa_np')" autocomplete="off" role="searchbox"
                            aria-multiline="false" aria-autocomplete="list"
                            data-params='{ "from":1 ,"czwartkomania":1 }' />
                          <input type="hidden" name="stid[0]"  class="jsTypeaheadItem-Value" onchange="window.app.stationChange(this)"/>
                          <p class="input-group-append">{{$t("icsearch_skad")}}</p>
                        </div>
                      </div>
                    </slot>
                    <a href="#" @click.prevent="reverse" class="switch d-flex h-100 align-items-center d-none"><i
                        class="bi bi-arrow-down-up"></i></a>
                  </div>
                  <slot name="lowcy-to">
                    <div role="combobox" aria-haspopup="listbox" aria-expanded="false" class="end no-border">
                      <div class="input-group">
                        <input type="search" id="stname-1" name="stname[1]"
                          :aria-label="$t('icsearch_aria_stacja_do')"
                          class="jsStationTypeaheadItem form-control" :placeholder="$t('icsearch_stacja_koncowa_np')"
                          autocomplete="off" role="searchbox" aria-multiline="false" aria-autocomplete="list"
                          data-params='{ "to":1 ,"czwartkomania":1 }' />
                        <input type="hidden" name="stid[1]" class="jsTypeaheadItem-Value" onchange="window.app.stationChange(this)"/>
                        <p class="input-group-append">{{$t("icsearch_dokad")}}</p>
                      </div>
                    </div>
                  </slot>
                  <div class="date-picker-container mt-3">
                    <div class="input-group single">
                        <div class="icpkp-datepicker w-100">
                          <ic-date-picker
                              v-model="date"
                              format="YYYY-MM-DD"
                              type="date"
                              id='date_picker'
                              name='date'
                              :hideControls="true"
                              title=""
                              :minDate="minDate"
                              :endDate="maxDate"
                          ></ic-date-picker>  
                        </div>
                    </div>
                  </div>
                </div>

                <input type="hidden" id="date" name="date" :value="date" />
                <input type="hidden" name="hafasPage" value="0" class="jsVariable-HafasPage" />
                <input type="hidden" name="hafasSort" value="" class="jsVariable-HafasSort" />
                <input type="hidden" name="search" value="1" class="jsVariable-HafasSort" />
              </form>
            </div>
          </div>
          <div class="col-11 col-xl-5 col-lg-6 h-100 d-lg-flex">
            <div class="promo-form ic-form header-form itinerary-form mb-auto py-5 flex-grow-1 pb-0">
            <fieldset>
              <legend class="">{{$t("icsearch_klasa_pociagu")}}</legend>

              <div class="form-check form-check-inline" v-for="klasa in klasaPociagu" :key="klasa.value">
                <input class="form-check-input" type="checkbox" name="class[]" :id="'inlineCheckboxClass'+klasa.value" :value="klasa.value" checked v-model="trainClass">
                <label class="form-check-label" :for="'inlineCheckboxClass'+klasa.value">{{klasa.name}}</label>
              </div>
            </fieldset>


            <fieldset>
              <legend class="">{{$t("icsearch_wybierz_klase_pociagu")}}</legend>

              <div class="form-check form-check-inline" v-for="kategoria in kategoriaPociagu" :key="kategoria.value">
                <input class="form-check-input" type="checkbox" name="category[]" :id="'inlineCheckbox'+kategoria.value" :value="kategoria.value" checked  v-model="trainCategory">
                <label class="form-check-label" :for="'inlineCheckbox'+kategoria.value">{{kategoria.name}}</label>
              </div>
            </fieldset>
          <fieldset>
              <legend class="">{{$t("icsearch_cena")}}</legend>
              <div class="d-flex">
                <div class="col-3 no-border" role="combobox">
                      <div class="input-group">
                        <input type="text" id="" name="cena"  class="form-control"  v-model="cena"/>
                        <p class="input-group-append">zł</p>
                      </div>
                </div>
                <div class="col-9"> 
                               <div aria-hidden="true" tabindex="-1" class="mt-2">
                <label for="customRange1" class="form-label sr-only">Suwak z ceną </label> <input tabindex="-1"  min="10" :max="maxCena"  v-model="cena" type="range" id="customRange1" class="form-range">
              </div></div>
              </div>


          </fieldset>            
          {{paging}}
            </div>
          </div>
          <div  class="col-11 col-xl-5 col-lg-6 h-100 d-lg-flex">
              <div class="promo-form ic-form header-form itinerary-form mb-auto flex-grow-1  pb-5">
                <button type="submit" class="btn btn-warning mt-3" @click.prevent="searchPromo(null,true  )">
                  {{$t("icsearch_wyszukaj")}}
                </button>
              </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
  import axios from 'axios'
  import objectToFormData, { serialize } from 'object-to-formdata'
  import IcDatePicker from "@/components/ic-common/form/controls/DatePicker.vue";
  import 'vue2-datepicker/index.css';
import moment from 'moment';

  export default {
    name: "section-lowcy-superpromo",
    props: {
      headerbg: { type: String, default: "" },
      stid1: String,
      stid0: String,
      stname0: String,
      stname1: String,
      date:{type: String, default:moment().add(1,"day").format("YYYY-MM-DD")},
      klasaPociagu: {type: Array, default:[{value:'2',name:'klasa 2'}]},
      kategoriaPociagu: {type: Array, default:[
              {value:'eip',name:'EIP'},
              {value:'eic',name:'EIC'},
          ]},
      maxCena: {String, default:"170"},
    },
    components: {
      VueTypeaheadBootstrap,
      IcDatePicker,
    },
    data() {
      return {
        paging: "",
        maxResults: 0,
        page: 1,
        sort: "sort:default",
        cena: 10,
        //stid1: this.stid1,
        //stid0: this.stid0,
        trainClass: [],
        trainCategory: [],
        isError:false,
        isSent:false,
        isSending:false,
        sentData: [],
        errorMessage: "",
        maxDate: moment().add(30,"day").format('YYYY-MM-DD'),
        minDate: moment().format('YYYY-MM-DD'),
      };
    },
    created: function () {
      for(var i=0; i< this.klasaPociagu.length;i++){
        this.trainClass.push(this.klasaPociagu[i].value);
      }
      for(var i=0; i< this.kategoriaPociagu.length;i++){
        this.trainCategory.push(this.kategoriaPociagu[i].value);
      }

this.cena = this.maxCena;
       this.$bus.$on('search-lowcy', this.searchPromo);
       this.$bus.$on('page-lowcy', this.changePage);
       this.$bus.$on('station-change', this.changeStation);
      
    },
    computed: {
  
    },
    methods: {
      changePage(data) { 
        this.page = $(data).data("page");
        this.searchPromo();
      },
      changeStation(data) { 
        this.page = 1;
        var val = data.value;
        var name = data.name;

        if(name == 'stid[0]') this.stid0 = val;
        if(name == 'stid[1]') this.stid1 = val;
      },

      searchPromo(data,reset = false) { 
        if(reset) this.page = 1;
        if(data && data.target && data.target.id == 'lowcySort'){
          this.sort=data.target.options[data.target.selectedIndex].value;
        }


        const formData = serialize({cena:this.cena,trainClass:this.trainClass,trainCategory:this.trainCategory,stid0: this.stid0, stid1: this.stid1, date: this.date,sort:this.sort,page:this.page});
        var that = this;
        document.getElementById("ic-search-results").classList.add("loading");
        axios({
        data: formData,
        method: 'post',
        responseType: 'json',
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: "lowcy-superpromo/search"
      })
        .then(res => {
          this.isError = true
          this.isSending = false
          console.log(res);

          if(res.data){
            //console.log(": data :",res.data.tickets);
            //if(res.data.allResultsAmount > 0)
              document.getElementById("suggested").innerHTML = res.data.tickets;
            //else
              //document.getElementById("parent-ic-search-results").innerHTML = res.data.tickets;

            that.maxResults = res.data.allResultsAmount;
            that.generatePaging();
            
            var e = $('#ic-search-results');
            if (e.length > 0) {
                
                $('body,html').animate({
                    'scrollTop' : e.offset().top - 150
                }, 200);
            }
          }
          document.getElementById("ic-search-results").classList.remove("loading");

        })
        .catch(() => {
          this.isError = true
          this.isSending = false
          this.errorMessage = this.$t('form_error_connection')
          this.$emit('lowcy:error', this.$t('form_error_connection'))
          document.getElementById("ic-search-results").classList.remove("loading");
        })


      },
      generatePaging(){
          var max = Math.ceil(this.maxResults/20);
          var pages = this.pageNumbers(max,this.page);
          var r = "";
          var p = [];
          if(pages.length){
            if(this.page > 1) {
              p.push('<li class="page-item"><a title=" Wróć do strony" class="page-link" onclick="app.lowcyPage(this)" data-page='+(this.page-1)+'><i aria-hidden="true" class="bi bi-chevron-left"></i></a></li>');
            } else {
              p.push('<li class="page-item disabled"><a title="Wróć do strony" disabled="disabled" class="page-link"><i aria-hidden="true" class="bi bi-chevron-left"></i></a></li>');
            }
          
            for(var i=0; i<pages.length;i++){
              if(pages[i] != '...')
                p.push('<li class="page-item '+(pages[i] == this.page?'active':'')+'"><a title="Strona '+(pages[i])+'" data-page="'+(pages[i])+'" class="page-link" onclick="app.lowcyPage(this)"><span class="sr-only">Strona </span>'+(pages[i])+'</a></li>');
              else 
              p.push('<li class="page-item">'+(pages[i])+'</li>');

            }

            if(this.page < max){
              p.push('<li class="page-item"><a title="Przejdź do strony '+(this.page+1)+'" class="page-link" onclick="app.lowcyPage(this)" data-page='+(this.page+1)+'><i aria-hidden="true" class="bi bi-chevron-right"></i></a></li>');
            } else {
              p.push('<li class="page-item"><a disabled="disabled" class="page-link"><i aria-hidden="true" class="bi bi-chevron-right"></i></a></li>');
            }
          }

          r =  p.join("");
          document.getElementById("stronnicowanie").innerHTML = r;

      },
      pageNumbers(count, current) {
        var result = [];

        for(var i = current;i>0 && i > current-4;i--)
          result.unshift(i);

        for(var i = current+1;i<current+4;i++)
          if(i <= count) 
            result.push(i);
        if(current < count-3)
          result.push('...', count);
        return result;
      },
      reverse() {
        let temp = this.stid1;
        this.stid1 = this.stid0;
        this.stid0 = temp;
      },
    },
  };
</script>